
import { styled } from '@mui/material';
import EDBox from '../../EDBox/EDBox';
import EDTypography from '../../Typography/EDTypography';
import { hourCaption } from '../Utils/EDCalendarViewUtils';

interface IProps {
  hour: number;
  showText?: boolean;
}
export const EDCalendarViewClockCell: React.FC<IProps> = props => (
  <ClockBox>
    {props.showText && <ClockText>{`${hourCaption(props.hour)}:00`}</ClockText>}
  </ClockBox>
);

const ClockBox = styled(EDBox, { name: 'ClockBox' })(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: -5,
  width: '90%',
  height: '50%',
  zIndex: 12,
  backgroundColor: theme.palette.background.paper,
}));

const ClockText = styled(EDTypography, { name: 'ClockText' })(({ theme }) => ({
  fontSize: 11,
  lineHeight: theme.spacing(1),
  textAlign: 'center',
}));
